import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SalesByLocationsService {

  private apiUrl = `${environment.Server_URL}/sales-locations`;

  constructor(private http: HttpClient) { }


getSalesLocations(city_id?: number, product_id?: number, page?: number, per_page?: number): Observable<any> {
let params = new HttpParams();
  if(page && per_page) {
    params = params
      .set('page', page)
      .set('per_page', per_page);

}
  
  if (city_id) params = params.set('city_id', city_id);
  if (product_id) params = params.set('product_id', product_id);

  return this.http.get(this.apiUrl, { params });
}

  /**
   * 🔴 DELETE — حذف سجل واحد
   */
  deleteLocation(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
